export default __webpack_public_path__ + "fonts/e71bda5d8dc5522e5325cff9bac2bb37.woff2";